module.exports = __webpack_public_path__ + "public/hws/images/logo-en.svg";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/logo-en.svg
// module id = 336
// module chunks = 0